import { ActivityState } from '@/lib/enums';

/**
 * Determines if an activity should be included based on the filter state.
 *
 * @param {Object}
 *
 * @param {string}
 */
export default function includeActivityByFilterState({
  activity,
  activityState,
}) {
  return (
    activityState === ActivityState.ALL ||
    (activityState === ActivityState.INACTIVE && activity.disabled_at) ||
    (activityState === ActivityState.ACTIVE && !activity.disabled_at)
  );
}
